import { render, staticRenderFns } from "./WorkflowField.vue?vue&type=template&id=e0252808&scoped=true"
import script from "./WorkflowField.vue?vue&type=script&lang=js"
export * from "./WorkflowField.vue?vue&type=script&lang=js"
import style0 from "./WorkflowField.vue?vue&type=style&index=0&id=e0252808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0252808",
  null
  
)

export default component.exports